(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-01-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.jl-announce[data-countdown-target]').forEach(initCountdown);

    // Barra clicable → baja a la compra del hero
    document.querySelectorAll('.jl-announce [data-jl-goto]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToOffer(btn.closest('.jl-announce')); });
    });

    // Condensar al hacer scroll: en móvil la promo colapsa y solo queda el countdown.
    var stickyBars = document.querySelectorAll('.jl-announce--sticky');
    if (stickyBars.length) {
      var condensed = false, condRaf = null;
      var onScrollCondense = function () {
        if (condRaf) return;
        condRaf = requestAnimationFrame(function () {
          condRaf = null;
          var should = window.pageYOffset > 16;
          if (should !== condensed) {
            condensed = should;
            stickyBars.forEach(function (b) { b.classList.toggle('jl-announce--condensed', should); });
          }
        });
      };
      window.addEventListener('scroll', onScrollCondense, { passive: true });
      onScrollCondense();
    }

    function goToOffer(announce) {
      var target = document.querySelector('[data-jl-offer], .jl-hero__buybox, .jl-hero__cta');
      if (!target) return;
      var headerEl = document.querySelector('.header-wrapper, .shopify-section-header, header');
      var headerH = (headerEl && headerEl.getBoundingClientRect().height) || 0;
      var announceH = (announce && announce.classList.contains('jl-announce--sticky')) ? (announce.getBoundingClientRect().height || 0) : 0;
      var top = window.pageYOffset + target.getBoundingClientRect().top - headerH - announceH - 16;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
    }

    function initCountdown(section) {
      var target = parseTarget(section.dataset.countdownTarget);
      if (!target || isNaN(target.getTime())) return;

      var expiredText = section.dataset.expiredText || '';
      var elDays = section.querySelector('[data-days]');
      var elHours = section.querySelector('[data-hours]');
      var elMinutes = section.querySelector('[data-minutes]');
      var elSeconds = section.querySelector('[data-seconds]');
      var elPromo = section.querySelector('.jl-announce__promo');
      var elCountdown = section.querySelector('[data-countdown]');
      var interval;

      function update() {
        var diff = target.getTime() - Date.now();
        if (diff <= 0) {
          clearInterval(interval);
          if (elCountdown) elCountdown.style.display = 'none';
          if (expiredText && elPromo) elPromo.textContent = expiredText;
          section.classList.add('jl-announce--expired');
          return;
        }
        // Si se muestran días, las horas van en módulo 24; si no, horas = total restantes.
        if (elDays) elDays.textContent = String(Math.floor(diff / 86400000));
        if (elHours) elHours.textContent = pad(elDays ? Math.floor(diff / 3600000) % 24 : Math.floor(diff / 3600000));
        if (elMinutes) elMinutes.textContent = pad(Math.floor(diff / 60000) % 60);
        if (elSeconds) elSeconds.textContent = pad(Math.floor(diff / 1000) % 60);
      }

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function parseTarget(s) {
        if (!s) return null;
        return new Date(s.replace(' ', 'T')); // hora local del visitante
      }

      update();
      interval = setInterval(update, 1000);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-banda-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcta]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.3 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-calculo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcalc]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-carta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcarta]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-cita"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcita]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.25 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-como-funciona"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcf]');
  if (!els.length) return;
  els.forEach(function (root) {
    root.classList.add('jcf--js'); // habilita el colapso (sin JS queda todo abierto)
    // Reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: 0.12 });
      io.observe(root);
    } else { root.classList.add('is-in'); }
    // Colapsable (efectivo solo en móvil; en desktop el CSS lo fuerza abierto)
    var steps = [].slice.call(root.querySelectorAll('.jcf__step--has'));
    steps.forEach(function (step, i) {
      var btn = step.querySelector('[data-jcf-toggle]');
      if (!btn) return;
      if (i === 0) { step.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); } // primer paso abierto
      btn.addEventListener('click', function () {
        var open = step.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-concentrado"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jconc]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-cuidamos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jcuid]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-jfaq]').forEach(function (root) {
    root.classList.add('jfaq--js'); // activa el modo animado (oculto sin JS)

    // Reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
      io.observe(root);
    } else { root.classList.add('is-in'); }

    var items = [].slice.call(root.querySelectorAll('[data-jfaq-item]'));

    function openItem(item, doScroll) {
      items.forEach(function (o) {
        if (o !== item) { o.classList.remove('is-open'); var b = o.querySelector('[data-jfaq-btn]'); if (b) b.setAttribute('aria-expanded', 'false'); }
      });
      item.classList.add('is-open');
      var btn = item.querySelector('[data-jfaq-btn]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (doScroll) {
        setTimeout(function () {
          var rect = item.getBoundingClientRect();
          window.scrollTo({ top: window.pageYOffset + rect.top - 90, behavior: 'smooth' });
        }, 60);
      }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('[data-jfaq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        if (willOpen) { openItem(item, false); }
        else { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    });

    // Apertura por hash (#faq-mascotas, etc.)
    function openByHash() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var target = null;
      try { target = root.querySelector(hash); } catch (e) { return; }
      if (!target) return;
      if (!target.classList.contains('jfaq__item')) { target = target.closest('.jfaq__item'); }
      if (!target) return;
      openItem(target, true);
    }
    openByHash();
    window.addEventListener('hashchange', openByHash);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var f = document.querySelector('[data-jftr]');
  if (f) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { f.classList.add('is-in'); io.disconnect(); } }); }, { threshold: 0.12 });
      io.observe(f);
    } else { f.classList.add('is-in'); }
  }
  // Sticky: añade un spacer una sola vez para no tapar el final del footer en móvil
  var sticky = document.querySelector('[data-jftr-sticky]');
  if (!sticky) return; // sticky desactivado (show_sticky:false) -> no montar spacer ni el IO de supresores
  if (!document.querySelector('[data-jftr-spacer]')) {
    var sp = document.createElement('div');
    sp.setAttribute('data-jftr-spacer', '');
    sp.setAttribute('aria-hidden', 'true');
    sp.style.height = '76px';
    sp.style.background = 'var(--c-granate)';
    var mq = window.matchMedia('(max-width: 859px)');
    var apply = function () { sp.style.display = mq.matches ? 'block' : 'none'; };
    apply(); mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    if (f && f.parentNode) f.parentNode.insertBefore(sp, f.nextSibling);
  }
  // Afinado del sticky (Enrique 22/06): aparece SOLO tras pasar el hero y se esconde cuando
  // ya hay un CTA de compra en pantalla. Supresores = el hero (#top) + todo enlace al
  // configurador (mismo destino que el sticky o cualquier ruta con "configura"): los
  // "Crea tu pack" del hero, bandas y footer. El sticky se ve únicamente cuando NINGÚN
  // supresor está a la vista. Conserva el empuje a compra en la "zona muerta" del medio,
  // sin competir con los CTA ni asomar desde el inicio.
  if ('IntersectionObserver' in window) {
    var link = sticky.querySelector('a');
    var target = '';
    try { target = new URL(link.getAttribute('href'), location.href).pathname.toLowerCase(); } catch (e) {}
    var suppressors = [];
    var hero = document.getElementById('top');
    if (hero) suppressors.push(hero);
    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (a) {
      if (sticky.contains(a)) return;
      var p; try { p = new URL(a.getAttribute('href'), location.href).pathname.toLowerCase(); } catch (e) { return; }
      if ((target && p === target) || p.indexOf('configura') !== -1) suppressors.push(a);
    });
    if (suppressors.length) {
      sticky.classList.add('is-hidden');
      var visible = new Set();
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
        var any = visible.size > 0;
        sticky.classList.toggle('is-hidden', any);
        sticky.setAttribute('aria-hidden', any ? 'true' : 'false');
      }, { threshold: 0 });
      suppressors.forEach(function (el) { sio.observe(el); });
    }
  }
})();

  /* Botellas sueltas: el enlace del footer (con data-jaspe-buy-bottle) abre un modal con selector
     de cantidad. El modal: vacía carrito + añade N (pago único) → /checkout. Sin modal → fallback a la ficha. */
  (function () {
    var modal = document.querySelector('[data-jbm]');
    if (!modal) {
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('[data-jaspe-buy-bottle]') : null;
        if (!b) return; e.preventDefault();
        var h = b.getAttribute('href'); if (h) window.location.href = h;
      });
      return;
    }
    var variant = parseInt(modal.dataset.variant, 10) || 0;
    var qty = 1;
    var offers = modal.querySelectorAll('[data-jbm-offer]');
    var qtyEl = modal.querySelector('[data-jbm-qty]');
    var totalEl = modal.querySelector('[data-jbm-total]');
    var errEl = modal.querySelector('[data-jbm-err]');
    var confirmBtn = modal.querySelector('[data-jbm-confirm]');
    function render() { if (qtyEl) qtyEl.textContent = qty; if (totalEl) totalEl.textContent = 'Comprar ' + qty + (qty === 1 ? ' botella' : ' botellas'); Array.prototype.forEach.call(offers, function (o) { var on = (parseInt(o.getAttribute('data-jbm-offer'), 10) || 0) === qty; o.classList.toggle('is-selected', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
    function closeModal() { try { modal.close(); } catch (e) { modal.removeAttribute('open'); } }
    var inc = modal.querySelector('[data-jbm-inc]'), dec = modal.querySelector('[data-jbm-dec]');
    if (inc) inc.addEventListener('click', function () { if (qty < 20) { qty++; render(); } });
    if (dec) dec.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
    Array.prototype.forEach.call(offers, function (o) { o.addEventListener('click', function () { qty = parseInt(o.getAttribute('data-jbm-offer'), 10) || 1; render(); }); });
    modal.querySelectorAll('[data-jbm-close]').forEach(function (x) { x.addEventListener('click', closeModal); });
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      if (confirmBtn.dataset.loading === '1') return;
      confirmBtn.dataset.loading = '1';
      var prev = totalEl ? totalEl.textContent : '';
      if (totalEl) totalEl.textContent = 'Procesando…';
      if (errEl) errEl.hidden = true;
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('clear ' + r.status); return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant, quantity: qty, properties: { _jaspeBottleSolo: '1' } }] }) }); })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); window.location.href = '/checkout'; })
        .catch(function (err) { console.error('JASPE bottle:', err); confirmBtn.dataset.loading = ''; if (totalEl) totalEl.textContent = prev; if (errEl) { errEl.textContent = 'No hemos podido procesar la compra. Inténtalo de nuevo o escríbenos a hola@jaspe.eco'; errEl.hidden = false; } });
    });
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-jaspe-buy-bottle]') : null;
      if (!b) return;
      e.preventDefault();
      qty = 1; render();
      if (modal.showModal) modal.showModal(); else modal.setAttribute('open', '');
    });
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-gracias-qr"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.jgq').forEach(function (root) {
      root.querySelectorAll('[data-jgq-faq-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-jgq-faq]');
          if (!item) return;
          var open = item.classList.toggle('jgq__faq-item--open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  })();

  /* Aparicion suave al entrar en pantalla. Blindado: el estado oculto solo existe si
     este JS marca la seccion, y una red de seguridad revela todo pase lo que pase. */
  (function () {
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (rm || !('IntersectionObserver' in window)) return; /* sin animacion: todo visible por defecto */

    document.querySelectorAll('.jgq').forEach(function (root) {
      var els = root.querySelectorAll('[data-jgq-reveal]');
      if (!els.length) return;
      root.classList.add('jgq--reveal'); /* activa el estado oculto SOLO ahora */

      var reveal = function (el) { el.classList.add('is-in'); };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
      els.forEach(function (el) { io.observe(el); });

      /* Red de seguridad: si el observer no dispara (pestana en 2o plano, navegador raro),
         a los 1,5 s se muestra todo. Mas vale sin animacion que invisible. */
      setTimeout(function () { els.forEach(reveal); }, 1500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-hablemos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jhab]');
  if (!els.length) return;

  // Toggle "Ver más / Ver menos"
  document.querySelectorAll('[data-jhab-toggle]').forEach(function (btn) {
    var card = btn.closest('.jhab__card');
    var panel = card ? card.querySelector('[data-jhab-more]') : null;
    if (!card || !panel) return;
    panel.removeAttribute('hidden');
    btn.addEventListener('click', function () {
      var willOpen = !card.classList.contains('is-open');
      card.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      var open = btn.getAttribute('data-label-open') || 'Ver menos';
      var closed = btn.getAttribute('data-label-closed') || 'Ver más';
      var ico = btn.querySelector('.jhab__link-ico');
      btn.textContent = (willOpen ? open : closed) + ' ';
      if (ico) btn.appendChild(ico);
    });
  });

  // Reveal
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-header-v3"] && !Shopify.designMode) return;
  try {
    
// Condensa el header al hacer scroll (sin scroll-timeline para soporte amplio).
(function () {
  var bars = document.querySelectorAll('[data-jhdr]');
  if (!bars.length) return;
  var onScroll = function () {
    var c = window.scrollY > 40;
    bars.forEach(function (b) { b.classList.toggle('is-condensed', c); });
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Logo del header: oculto mientras el HERO (#top) está en pantalla; aparece
// suave al pasarlo (igual que en el diseño). Si no hay #top (páginas sin hero)
// o el tema lo desactiva, el logo se queda visible.
(function () {
  var hero = document.getElementById('top');
  var logos = document.querySelectorAll('[data-jhdr][data-logo-reveal] .jhdr__logo');
  if (!logos.length || !hero || !('IntersectionObserver' in window)) return;
  logos.forEach(function (l) {
    l.style.transition = 'opacity .45s ease, transform .45s ease';
    l.style.opacity = '0'; l.style.transform = 'translateY(-4px)'; l.style.pointerEvents = 'none';
  });
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      var hidden = en.isIntersecting;
      logos.forEach(function (l) {
        l.style.opacity = hidden ? '0' : '1';
        l.style.transform = hidden ? 'translateY(-4px)' : 'none';
        l.style.pointerEvents = hidden ? 'none' : 'auto';
      });
    });
  }, { threshold: 0, rootMargin: '-65px 0px 0px 0px' });
  io.observe(hero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var heroes = document.querySelectorAll('[data-jhero]');
  if (!heroes.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  heroes.forEach(function (hero) {
    // Reveal al entrar
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { hero.classList.add('is-in'); io.disconnect(); } });
      }, { threshold: 0.18 });
      io.observe(hero);
    } else {
      hero.classList.add('is-in');
    }

    // Parallax del mesh (solo puntero fino, sin reduced-motion)
    var mesh = hero.querySelector('[data-jhero-mesh]');
    var fine = window.matchMedia('(pointer: fine)').matches;
    if (!mesh || reduce || !fine) return;

    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      mesh.style.transition = 'transform .4s cubic-bezier(.16,1,.3,1)';
      mesh.style.transform = 'translate(' + (x * 30).toFixed(1) + 'px,' + (y * 30).toFixed(1) + 'px) scale(1.05)';
    });
    hero.addEventListener('pointerleave', function () {
      mesh.style.transition = 'transform .9s cubic-bezier(.16,1,.3,1)';
      mesh.style.transform = 'translate(0,0) scale(1)';
    });
    hero.addEventListener('pointerdown', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      mesh.style.transition = 'transform .45s cubic-bezier(.16,1,.3,1)';
      mesh.style.transform = 'translate(' + (x * 54).toFixed(1) + 'px,' + (y * 54).toFixed(1) + 'px) scale(1.14)';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-modelo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jmod]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.3 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-preparar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jprep]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.18 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-quees"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jquees]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.2 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-regalo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-jaspe-regalo]');
    if (!root) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var tEl = root.querySelector('[data-jr-title]');
    var xEl = root.querySelector('[data-jr-text]');
    var AROMAS = { '1':'Jazmín en Flor', '2':'Noble Petal', '3':'Pomelo', '4':'Vainilla', '5':'Ayurveda', '6':'Tropical' };

    function apply(titleKey, textKey, scent) {
      if (tEl && root.dataset[titleKey]) tEl.textContent = root.dataset[titleKey];
      if (xEl && root.dataset[textKey]) xEl.textContent = root.dataset[textKey].replace('{scent}', scent || 'tu esencia');
    }

    // --- One-tap: elección de aroma. SUB (?c=&s=&a=&r=&sig=) o NO-SUB (?c=&a=&r=&sig=&n=1) ---
    var c = params.get('c'), s = params.get('s'), a = params.get('a'), r = params.get('r'), sig = params.get('sig'), n = params.get('n');

    // SUB: tiene sub_id (s) → webhook del suscriptor (Task B inyecta en Loop)
    if (s && a && sig) {
      var aroma = AROMAS[a] || 'tu esencia';
      var hook = root.getAttribute('data-webhook') || '';
      if (hook) {
        try {
          fetch(hook, {
            method: 'POST', mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'c=' + encodeURIComponent(c || '') + '&s=' + encodeURIComponent(s) + '&a=' + encodeURIComponent(a) + '&r=' + encodeURIComponent(r || '') + '&sig=' + encodeURIComponent(sig)
          });
        } catch (e) {}
      }
      apply('titleOk', 'textOk', aroma);
      return;
    }

    // NO-SUB: marcado con n=1, sin sub_id → webhook propio (Task NS-2 guarda la elección para Ana)
    if (n && a && sig) {
      var aromaN = AROMAS[a] || 'tu esencia';
      var hookN = root.getAttribute('data-webhook-nosub') || '';
      if (hookN) {
        try {
          fetch(hookN, {
            method: 'POST', mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'c=' + encodeURIComponent(c || '') + '&a=' + encodeURIComponent(a) + '&r=' + encodeURIComponent(r || '') + '&sig=' + encodeURIComponent(sig) + '&n=1'
          });
        } catch (e) {}
      }
      apply('titleOk', 'textOk', aromaN);
      return;
    }

    // --- Modo clásico (?status=ok&scent=…), por si se usa vía redirect ---
    var status = (params.get('status') || params.get('ok') || '').toLowerCase();
    var scent = params.get('scent') || params.get('aroma') || '';
    if (status === 'ok' || status === '1' || status === 'true') {
      apply('titleOk', 'textOk', scent);
    } else if (status === 'error' || status === 'expired') {
      apply('titleError', 'textError', scent);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-resenas"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-jrev]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
  els.forEach(function (e) { io.observe(e); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-js-strip-bar]').forEach(function (bar) {
      var sec = bar.closest('.js-strip');
      if (!sec || !sec.classList.contains('js-strip--sticky')) return;
      var spacer = sec.querySelector('[data-js-strip-spacer]');
      var top = 0;
      function measure() { sec.classList.remove('js-strip--is-fixed'); if (spacer) spacer.style.height = '0px'; top = sec.getBoundingClientRect().top + window.pageYOffset; }
      function onScroll() {
        var fixed = window.pageYOffset >= top;
        sec.classList.toggle('js-strip--is-fixed', fixed);
        if (spacer) spacer.style.height = fixed ? bar.offsetHeight + 'px' : '0px';
      }
      measure(); onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jaspe-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-jact]').forEach(function (root) {
    // Reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
      io.observe(root);
    } else { root.classList.add('is-in'); }

    // Flechas
    var rail = root.querySelector('[data-jact-rail]');
    var prev = root.querySelector('[data-jact-prev]');
    var next = root.querySelector('[data-jact-next]');
    if (rail && prev && next) {
      var step = function () { return Math.round(rail.clientWidth * 0.8); };
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    // Autoplay en viewport (pausa fuera) + primer fotograma siempre visible + sonido exclusivo
    var vids = root.querySelectorAll('[data-jact-video]');
    if (!vids.length) return;

    // Refuerzo: en Android/WebView #t=0.1 a veces no pinta -> forzar el primer frame una vez
    vids.forEach(function (v) {
      v.addEventListener('loadeddata', function () {
        if (!v.dataset.seeked) { try { v.currentTime = 0.1; } catch (e) {} v.dataset.seeked = '1'; }
      });
    });

    // Sonido: solo una tarjeta con audio a la vez (mantiene muted-first => autoplay intacto)
    function jactMuteAll(except) {
      root.querySelectorAll('[data-jact-sound]').forEach(function (btn) {
        if (btn === except) return;
        var card = btn.closest('.jact__card');
        var vv = card && card.querySelector('[data-jact-video]');
        if (vv) vv.muted = true;
        btn.classList.remove('is-on');
        btn.setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-label', 'Activar sonido');
      });
    }
    root.querySelectorAll('[data-jact-sound]').forEach(function (btn) {
      var card = btn.closest('.jact__card');
      var v = card && card.querySelector('[data-jact-video]');
      if (!v) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var turningOn = !btn.classList.contains('is-on');
        jactMuteAll(btn);
        if (turningOn) {
          v.muted = false; v.volume = 1;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Silenciar');
        } else {
          v.muted = true;
          btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Activar sonido');
        }
      });
    });

    if (reduce || !('IntersectionObserver' in window)) return; // sin autoplay: queda el primer fotograma (#t=0.1)

    function jactResetSound(v) {
      if (v.muted) return;
      v.muted = true;
      var card = v.closest('.jact__card');
      var btn = card && card.querySelector('[data-jact-sound]');
      if (btn) { btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Activar sonido'); }
    }

    // Warm: precarga el clip de las tarjetas a punto de entrar (no los 8 a la vez)
    var warm = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting && en.target.preload !== 'auto') en.target.preload = 'auto'; });
    }, { root: rail, rootMargin: '0px 200px 0px 200px', threshold: 0 });
    vids.forEach(function (v) { warm.observe(v); });

    // Play: arranca antes de estar 100% centrada y pausa al salir lateralmente
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); jactResetSound(v); }
      });
    }, { root: rail, rootMargin: '0px -10% 0px -10%', threshold: 0.35 });
    vids.forEach(function (v) { vio.observe(v); });

    // Sección fuera de vista VERTICAL: el IO de play (vio) usa root:rail y solo reacciona
    // al scroll HORIZONTAL, así que no detecta el scroll vertical. Al SALIR pausamos todos;
    // al VOLVER hay que REANUDAR el/los vídeo(s) centrados en el rail (antes solo pausaba y
    // nada los reanudaba → había que hacer swipe lateral para reactivarlos).
    function jactPlayVisible() {
      if (!rail || !rail.offsetParent) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
      var rr = rail.getBoundingClientRect();
      vids.forEach(function (v) {
        var vr = v.getBoundingClientRect();
        var cx = vr.left + (vr.width / 2);
        if (cx > rr.left && cx < rr.right) { // centro del vídeo dentro del rail visible
          v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    }
    var secIO = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { jactPlayVisible(); }
        else { vids.forEach(function (v) { v.pause(); jactResetSound(v); }); }
      });
    }, { threshold: 0.01 });
    secIO.observe(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
